import { useTranslation } from "react-i18next";
import { Box, Container, Flex, Text } from "@chakra-ui/react";
import { fillLegalDate } from "../../../utils/legalDate";
import LegalVersionNote from "../../legal/LegalVersionNote";

const SectionParagraph = ({ children }) => (
    <Text
        fontWeight={400}
        fontSize={'15px'}
        lineHeight={'26px'}
        color={'#3B3033'}
    >
        {children}
    </Text>
);

const PriceList = () => {
    const { t } = useTranslation("price-list");

    const paragraphs = [
        's1.p1',
        's1.p2',
        's1.p3',
        's1.p4',
        's1.p5',
    ];

    return (
        <>
            <Box w={'full'} fontFamily="body">
                <Container maxW={'7xl'} py={'64px'}>
                    <Flex flexDirection={'column'} gap={'8px'}>

                        {/* Nagłówek strony */}
                        <Text
                            fontWeight={700}
                            fontSize={'26px'}
                            lineHeight={'38px'}
                            color={'#1E1517'}
                            textAlign={'center'}
                            mb={'4px'}
                        >
                            {t('page_title')}
                        </Text>

                        {/* Metadane */}
                        <Flex gap={'16px'} flexDirection={{ base: 'column', sm: 'row' }} mb={'32px'}>
                            <Text fontWeight={400} fontSize={'13px'} color={'#6E6064'}>
                                {fillLegalDate(t('effective_date'))}
                            </Text>
                            <Text fontWeight={400} fontSize={'13px'} color={'#6E6064'}>
                                {fillLegalDate(t('version'))}
                            </Text>
                        </Flex>

                        <LegalVersionNote doc="price-list" />
                        {/* Separator */}
                        <Flex w={'full'} h={'1px'} bg={'#ECE4E4'} mb={'32px'} />

                        {/* Punkty cennika */}
                        <Flex gap={'16px'} flexDirection={'column'} w={'full'}>
                            {paragraphs.map((pKey) => (
                                <SectionParagraph key={pKey}>
                                    {t(pKey)}
                                </SectionParagraph>
                            ))}
                        </Flex>

                    </Flex>
                </Container>
            </Box>
        </>
    );
};

export default PriceList;
